export default {"src":"/_next/static/media/KneeDegeneration.0eafeb86.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};